import {useConfig} from '@aboutyou/config';
import {useTranslation} from '@aboutyou/i18n';
import {ConsentServices} from '@aboutyou/storage';
import {COLORS, Text, useIsomorphicLayoutEffect} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC, useCallback, useEffect, useState} from 'react';

export const TradedoublerConsentBody: FC<{className?: string}> = ({
  className,
}) => {
  const {t} = useTranslation();
  const {device} = useConfig();
  const [readMoreTextContent, setReadMoreTextContent] = useState<
    string | null
  >();

  const getCmpControllerConsentDescription = useCallback(() => {
    if (!readMoreTextContent) {
      window.__ucCmp
        .changeLanguage(window.__ucCmp.cmpController.ui.language)
        .then(() =>
          window.__ucCmp.cmpController
            .getServiceInfo(ConsentServices.Tradedoubler)
            .then(content => {
              // eslint-disable-next-line local-rules/set-state-in-use-effect
              setReadMoreTextContent(content.i18n.description);
            }),
        );
    }
  }, [readMoreTextContent]);

  useIsomorphicLayoutEffect(() => {
    if (typeof document !== 'undefined') {
      const elements = document.querySelectorAll(
        '[data-testid="consentManagementCenter"]',
      );

      elements.forEach((element, index) =>
        element.addEventListener('click', () => {
          if (index === 0) {
            window.UC_UI?.showSecondLayer();
          } else {
            window.UC_UI?.showSecondLayer();
            const ucsrContent = setInterval(() => {
              if (document) {
                if (
                  document
                    .getElementById('usercentrics-cmp-ui')
                    ?.shadowRoot?.getElementById('categories-tab-button')
                ) {
                  clearInterval(ucsrContent);
                  const ucsr = document.getElementById(
                    'usercentrics-cmp-ui',
                  )?.shadowRoot;
                  ucsr
                    ?.getElementById('categories-tab-button')
                    ?.classList.remove('active');
                  ucsr
                    ?.getElementById('categoriesPanel')
                    ?.classList.remove('active');
                  ucsr
                    ?.getElementById('services-tab-button')
                    ?.classList.add('active');
                  ucsr
                    ?.getElementById('servicesPanel')
                    ?.classList.add('active');
                }
              }
            }, 10);
          }
        }),
      );

      const closeOnOverlayClick = () => {
        const container = document.querySelector('#usercentrics-cmp-ui');
        const overlay =
          container?.shadowRoot?.querySelector('.uc-modal-overlay');
        if (overlay) {
          overlay.addEventListener('click', () => {
            const closeButton = container?.shadowRoot?.querySelector(
              '.modal-close-button',
            );
            if (closeButton) {
              (closeButton as HTMLElement).click();
            }
          });
        }
      };

      const ga4Element = document.querySelector('[data-testid="consent-ga4"]');
      if (ga4Element) {
        ga4Element.addEventListener('click', () => {
          window.__ucCmp.showServiceDetails(ConsentServices.GA4);
          setTimeout(() => {
            closeOnOverlayClick();
          }, 100);
        });
      }
      const tradedoublerElement = document.querySelector(
        '[data-testid="consent-tradedoubler"]',
      );
      if (tradedoublerElement) {
        tradedoublerElement.addEventListener('click', () => {
          window.__ucCmp.showServiceDetails(ConsentServices.Tradedoubler);
          setTimeout(() => {
            closeOnOverlayClick();
          }, 100);
        });
      }
      const storageElement = document.querySelector(
        '[data-testid="consent-storage"]',
      );
      if (storageElement) {
        storageElement.addEventListener('click', () => {
          window.__ucCmp.showServiceDetails(ConsentServices.Storage);
          setTimeout(() => {
            closeOnOverlayClick();
          }, 100);
        });
      }
    }
  });

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    window.bt.evt.push({
      event: 'consent',
      eventData: {
        location: 'customBanner',
        action: 'impression',
        feature: 'Payback',
      },
    });

    if (
      window.__ucCmp &&
      window.__ucCmp.cmpController &&
      window.__ucCmp.cmpController.ui
    ) {
      getCmpControllerConsentDescription();
    }
  }, []);

  return (
    <Wrapper className={className} data-mobile-stack={device === 'mobile'}>
      <StyledTextWithoutMargin
        as="p"
        size="px16"
        weight="mediumHeavy"
        color="Text.Black"
      >
        {t(
          'In order to collect PAYBACK points for your purchase,  you must consent to data processing by us and our partner for the following services: Tradedoubler, Google Analytics 4 and the Storage and/or retrieval of information on your device.',
        )}
      </StyledTextWithoutMargin>
      <StyledTextWithHyperlink
        as="p"
        size="px12"
        weight="mediumBold"
        color="Fill.Grey.Secondary"
        dangerouslySetInnerHTML={{
          __html: t('tradedoubler_feature_based_consent_body'),
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 500px;

  &[data-mobile-stack='true'] {
    padding: 16px;
    overflow: auto;
    min-height: 600px;
  }
`;

const StyledTextWithoutMargin = styled(Text)`
  margin: 0;
`;

const StyledTextWithHyperlink = styled(Text)`
  line-height: 18px;
  a {
    text-decoration: underline;
    color: ${COLORS['Fill.Grey.Secondary']};
  }

  span {
    text-decoration: underline;
    cursor: pointer;
  }
`;
